import FileUpload from "./fileUpload";
import TokenManager from "./tokenManager";

const API = {
    FileUpload,
    TokenManager,
};

export default API;
